import React, { useState } from "react";
import classes from "./Dropdown.module.css";
import ArrowBottomIcon from "mdi-react/ArrowBottomIcon";
// import { ArrowDown } from "react-bootstrap-icons";

function Dropdown({ options, selected, setSelected, classname }) {
  const [isActive, setIsActive] = useState(false);
  return (
    <div className={`${classes.dropdown} ${classname}`}>
      <div
        className={classes.dropdownBtn}
        onClick={(e) => {
          setIsActive(!isActive);
        }}
      >
        {selected}
        <span style={{ fontWeight: "bold" }}>
          <ArrowBottomIcon />
        </span>
      </div>
      {isActive && (
        <div className={classes.dropdownContent}>
          {options?.map((option, index) => (
            <div
              key={index}
              onClick={(e) => {
                setSelected(option);
                setIsActive(false);
              }}
              className={classes.dropdownItem}
            >
              {option}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Dropdown;
